import { useEffect, useState } from 'react';
import { handleTrack } from '../../../utils/tracker';
import CMSPageDataServices from '../../cms/services/cms-pages.service';

export const Trending = ({
  domainVal = 1,
}: {
  domainVal?: number;
}): JSX.Element => {
  const [open, setOpen] = useState(false);
  const [response, setResponse] = useState({
    recentData: [],
  });
  const MAX_TRENDING = 20;
  useEffect(() => {
    const trendingData = async () => {
      const trendingPost = CMSPageDataServices.getTrendingPosts(domainVal);
      const { data: recentData } = await trendingPost;

      if (recentData.length > MAX_TRENDING) {
        setResponse({
          recentData: recentData.slice(0, MAX_TRENDING),
        });
      } else {
        setResponse({
          recentData: recentData,
        });
      }
    };
    trendingData();
  }, []);

  const handleDropDown = (e: React.MouseEvent | React.TouchEvent) => {
    setOpen((prevOpenState) => !prevOpenState);
    handleTrack({
      label: 'trending_dropdown',
      obj: e.target,
    });
  };
  const handleEvent = (e: React.MouseEvent | React.TouchEvent) => {
    handleTrack({
      label: `trending_keyword`,
      obj: e.target,
    });
  };
  return (
    <div className="flex my-6 sm:mb-10" data-testid="Treanding">
      <ul
        className={`flex flex-wrap gap-3 overflow-hidden min-w-[90%] pr-2 ${
          open ? 'h-auto' : 'h-7'
        }`}
      >
        {response.recentData?.map(
          (item: { permalink: string; title: string }) => {
            return (
              <li
                style={{
                  borderWidth: '0.5px',
                }}
                className="cursor-pointer h-6 rounded-sm  border-solid border-gray-300 bg-grey-100 hover:bg-[#586B85] transition-all"
                key={item.title}
              >
                <a
                  className="text-grey-970 text-s-14 block px-3 hover:text-grey-100"
                  href={`/glossary/${item.permalink}`}
                  onClick={handleEvent}
                >
                  {item.title}
                </a>
              </li>
            );
          }
        )}
      </ul>
      <img
        onClick={handleDropDown}
        className={`w-6 h-6 flex-shrink-0 ${
          open ? 'rotate-180 open' : 'close'
        }`}
        alt="drop-arrow"
        src="https://assets.clear.in/cleartax/images/1695202791_group181438461.png"
      />
    </div>
  );
};
